import { Box, Button, MenuItem, TextField } from "@mui/material";
import { PropValueLine } from "../../common/PropValueLine";
import { WorldRenderer } from "../../WorldRenderer";
import { useEffect, useState } from "react";
import { RobotVisual } from "../../../visuals/RobotVisual";
import { ArmVisual } from "../../../visuals/ArmVisual";
import { Vec3Editor } from "../../common/Vec3Editor";
import { Vec3 } from "../../../models/SyntheticMap";
import * as THREE from "three";
import { WREvents } from "../../WREvents";

export function ArmProps({ wr, arm: arm, onUpdate }: {
  wr: WorldRenderer,
  arm: ArmVisual,
  onUpdate: (robot: Partial<ArmVisual>) => void
}) {
  const [robotVisuals, setRobotVisuals] = useState<RobotVisual[]>([]);
  const [targetPos, setTargetPos] = useState<Vec3>({ x: 0, y: 0, z: 0 });
  const [selectedCameraIndex, setSelectedCameraIndex] = useState<number>(-1);
  useEffect(() => {
    const rs = Array.from(wr.dataService.visuals.values())
      .filter(v => v instanceof RobotVisual && v._id !== arm._id) as RobotVisual[];
    setRobotVisuals(rs);
  }, [wr]);
  return (
    <>
      <PropValueLine label='Attach to' value={
        <TextField
          fullWidth
          select
          value={arm.parentId}
          variant="standard"
          size="small"
          onChange={(e) => {
            onUpdate({ parentId: e.target.value });
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {robotVisuals.map((r) => (
            <MenuItem key={r._id} value={r._id}>
              {r.id}
            </MenuItem>
          ))}
        </TextField>
      } />
      <PropValueLine label='Idle Pos' value={
        <Vec3Editor
          value={arm.idlePosition}
          onChange={(value) => {
            onUpdate({ idlePosition: value });
          }}
        />
      } />
      <PropValueLine label='Target Pos' value={
        <Vec3Editor
          value={targetPos}
          onChange={(value) => {
            setTargetPos(value);
          }}
          onSelect={() => {
            wr.userEventer.positionSelectAction = (position: THREE.Vector3) => {
              setTargetPos({ x: position.x, y: position.y, z: position.z });
            };
          }}
        />
      } />
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
        <Button color="secondary" onClick={() => {
          arm.moveArm(targetPos);
        }}>
          Move
        </Button>
        <Button sx={{ marginLeft: 2 }} color="secondary" onClick={() => {
          if (selectedCameraIndex > -1) {
            arm.wr.emitEvent(WREvents.CameraSelected, null);
            setSelectedCameraIndex(-1);
            return;
          }
          const cameraConfigs = arm.getCameras();
          if (cameraConfigs.length > 0) {
            arm.wr.emitEvent(WREvents.CameraSelected, arm, 0);
            setSelectedCameraIndex(0);
          }
        }}>
          Camera
        </Button>
      </Box>
    </>
  );
} 